// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1__c7adac8d797717c77de6","cls2":"Reader-cls2___979d0185d6acae38425 Reader-cls1__c7adac8d797717c77de6"};